module.exports = __webpack_public_path__ + "img/Logs.4cd5689a.svg";